<template>
  <div class="dashboard-page">
    <h1 class="dashboard-title">Dashboard</h1>

    <!-- Button zum Erfassen eines neuen Ladevorgangs -->
    <div class="new-session-button">
      <button @click="showChargingSessionForm = true">Neuen Ladevorgang erfassen</button>
    </div>

    <!-- Zeige die ChargingSessionForm-Komponente -->
    <div v-if="showChargingSessionForm" class="modal-overlay">
      <div class="modal-content">
        <ChargingSessionForm @close="showChargingSessionForm = false" @saved="fetchAllData" />
      </div>
    </div>

    <div class="time-range-selector">
      <label
        v-for="range in timeRanges"
        :key="range.value"
        :class="['time-range-option', { active: selectedTimeRange === range.value }]"
      >
        <span>{{ range.label }}</span>
        <input
          type="radio"
          name="timeRange"
          class="hidden-radio"
          :value="range.value"
          v-model="selectedTimeRange"
          @change="updateData"
        />
      </label>
    </div>

    <!-- Benutzerdefinierter Zeitraum -->
    <div v-if="selectedTimeRange === 'custom'" class="custom-range">
      <label>
        Startdatum:
        <input type="date" v-model="customRange.startDate" />
      </label>
      <label>
        Enddatum:
        <input type="date" v-model="customRange.endDate" />
      </label>
      <button @click="updateData">Anwenden</button>
    </div>

    <div class="stat-cards">
      <div class="stat-card">
        <p class="stat-value">{{ data.totalSessions }}</p>
        <p class="stat-title">Ladevorgänge</p>
      </div>
      <div class="stat-card">
        <p class="stat-value">{{ data.avgCost }} <span class="stat-unit">€/100 km</span></p>
        <p class="stat-title">⌀ Kosten</p>
      </div>
      <div class="stat-card">
        <div class="stat-value-wrapper">
          <p class="stat-value">{{ data.avgConsumption }}</p>
          <span class="stat-unit">kWh/100 km</span>
        </div>
        <p class="stat-title">⌀ Verbrauch</p>

      </div>
    </div>

    <div>
      <div class="chart-container">
        <p class="stat-title">Verbrauch kWh/100km</p>
        <canvas id="consumption-chart"></canvas>
      </div>
      <!-- Ladekurven-Diagramm -->
      <div class="chart-container">
        <p class="stat-title">Ladekurve (SOC vs. Ladeleistung)</p>
        <canvas id="curve-chart"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js/auto'
import axios from 'axios'
import ChargingSessionForm from './ChargingSessionForm.vue'
import { shallowRef } from 'vue'

export default {
  components: {
    ChargingSessionForm
  },
  data () {
    return {
      showChargingSessionForm: false, // Initialwert für das Anzeigen des Formulars
      selectedTimeRange: 'year',
      timeRanges: [
        { value: 'week', label: 'Letzte 7 Tage' },
        { value: 'month', label: 'Letzte 30 Tage' },
        { value: 'year', label: 'Letzte 365 Tage' },
        { value: 'custom', label: 'Benutzerdefiniert' }
      ],
      customRange: {
        startDate: '',
        endDate: ''
      },
      data: {
        consumption: 0.0,
        cost: 0.0,
        chargingSessions: 0,
        chartData: {}
      },
      loading: false,
      userId: null,
      localData: [], // Lokale Daten aus der Datenbank
      consumptionData: {}, // Verbrauchsdaten für das Verbrauchsdiagramm
      consumptionChartInstance: shallowRef(null), // Instanz des Verbrauchsdiagramms
      curveData: {}, // Verbrauchsdaten für das Ladekurvendiagramm
      curveChartInstance: null // Instanz des Ladekurvendiagramms
    }
  },
  computed: {
    user () {
      // console.log('Benutzer:', this.$store.getters.getUser)
      return this.$store.getters.getUser // Holt den aktuellen User aus Vuex
    }
  },
  mounted () {
    // this.userId = this.user?.id
    // if (this.userId) {
    this.fetchAllData() // Datenbankabfrage beim Seitenaufruf
    // } else {
    // console.error('Benutzer nicht authentifiziert.')
    // }
  },
  methods: {
    updateData () {
      const filteredData = this.filterDataByRange() // Filtere Daten basierend auf Zeitraum
      const averages = this.calculateAverages(filteredData)
      // console.log('updateData ()')
      this.consumptionData = {
        avgConsumption: averages.avgConsumption,
        avgCost: averages.avgCost,
        totalSessions: averages.totalSessions,
        chartData: this.generateConsumptionChartData(filteredData) // Generiere Diagrammdaten
      }
      // console.log('renderConsumptionChart aus updateData', this.data)
      console.log('Data in updateData:', this.consumptionData.chartData.data)
      this.renderConsumptionChart() // Diagramm aktualisieren
    },
    async fetchAllData () {
      // console.log('fetchAllData ()')
      try {
        const response = await axios.get('/api/getUserDashboardData.php')//, {
        // params: { userId: this.userId }
        // })
        // console.log('API Daten:', response.data)
        this.localData = response.data // Speichere alle Daten lokal
        // console.log('Lokale Daten:', this.localData)
        this.updateConsumptionData() // Zeige initiale Verbrauchsdaten
        this.updateCurveData() // Zeige initiale Daten für das Ladekurvendiagramm
      } catch (error) {
        console.error('Fehler beim Abrufen der Benutzerdaten:', error)
      }
    },
    calculateAverages (filteredData) {
      // Prüfe und logge die gefilterten Daten
      // console.log('calculateAvergages()')
      // console.log('Gefilterte Daten:', filteredData)
      // Wandelt Strings in Zahlen um
      const totalEnergy = filteredData.reduce((sum, entry) => sum + parseFloat(entry.energy || 0), 0)
      // console.log('Gesamtenergie:', totalEnergy)
      const totalCost = filteredData.reduce((sum, entry) => sum + parseFloat(entry.cost || 0), 0)
      // console.log('Gesamtkosten:', totalCost)
      const totalDistance = filteredData.reduce((sum, entry) => sum + parseFloat(entry.distance_driven || 0), 0)
      // console.log('Gesamtdistanz:', totalDistance)

      const avgConsumption = totalDistance > 0 ? (totalEnergy / totalDistance) * 100 : 0
      // console.log('Durchschnittsverbrauch:', avgConsumption)
      const avgCost = totalDistance > 0 ? (totalCost / totalDistance) * 100 : 0
      // console.log('Durchschnittskosten:', avgCost)

      this.data = {
        avgConsumption: avgConsumption.toFixed(1),
        avgCost: avgCost.toFixed(1),
        totalSessions: filteredData.length
      }
      // console.log('Durchschnittswerte calculateAverages:', this.data)
      return this.data
    },
    filterDataByRange () {
      // console.log('filteredDataByRange ()')
      const today = new Date()
      let startDate, endDate

      if (this.selectedTimeRange === 'week') {
        startDate = new Date(today)
        startDate.setDate(today.getDate() - 6)
        endDate = today
      } else if (this.selectedTimeRange === 'month') {
        startDate = new Date(today)
        startDate.setDate(today.getDate() - 29)
        endDate = today
      } else if (this.selectedTimeRange === 'year') {
        startDate = new Date(today)
        startDate.setDate(today.getDate() - 365)
        endDate = today
      } else if (this.selectedTimeRange === 'custom') {
        startDate = new Date(this.customRange.startDate)
        endDate = new Date(this.customRange.endDate)

        if (startDate > endDate) {
          alert('Das Anfangsdatum war nach dem Enddatum. Die Werte wurden angepasst.')
          ;[startDate, endDate] = [endDate, startDate]
          this.customRange.startDate = startDate.toISOString().split('T')[0]
          this.customRange.endDate = endDate.toISOString().split('T')[0]
        }
      }

      // Prüfe und logge die gefilterten Daten
      // console.log('Zeitraum von: ', startDate, ' bis: ', endDate)

      return this.localData.filter((entry) => {
        const entryDate = new Date(entry.date)
        return entryDate >= startDate && entryDate <= endDate
      })
    },
    updateConsumptionData () {
      // console.log('updateConsumptionData ()')
      const filteredData = this.filterDataByRange() // Filtere lokale Daten
      const averages = this.calculateAverages(filteredData)

      this.consumptionData = {
        consumption: averages.avgConsumption,
        cost: averages.avgCost,
        chargingSessions: averages.totalSessions,
        chartData: this.generateConsumptionChartData(filteredData) // Generiere Diagrammdaten
      }
      // console.log('renderConsumptionChart aus updateConsumptionData', this.data)
      console.log('Data in updateConsumptionData:', this.consumptionData.chartData.data)
      this.renderConsumptionChart()
    },
    generateConsumptionChartData (filteredData) {
      // console.log('generateConsumptionChartData ()')
      const groupedData = {}
      const labels = []
      const chartData = []

      if (this.selectedTimeRange === 'year') {
        // Initialisiere alle Monate mit 0
        const months = []
        const today = new Date()
        for (let i = 11; i >= 0; i--) {
          const month = new Date(today.getFullYear(), today.getMonth() - i, 1).toLocaleDateString('de-DE', { month: 'short' })
          months.push(month)
        }

        months.forEach((month) => {
          groupedData[month] = { energy: 0, cost: 0, distance: 0, count: 0 }
        })

        // Gruppiere nach Monat
        filteredData.forEach((entry) => {
          const date = new Date(entry.date)
          const monthLabel = date.toLocaleDateString('de-DE', { month: 'short' })

          if (groupedData[monthLabel]) {
            groupedData[monthLabel].energy += parseFloat(entry.energy || 0)
            groupedData[monthLabel].cost += parseFloat(entry.cost || 0)
            groupedData[monthLabel].distance += parseFloat(entry.distance_driven || 0)
            groupedData[monthLabel].count += 1
          }
        })

        // Erstelle Labels und aggregierte Werte für das Diagramm
        months.forEach((month) => {
          labels.push(month)
          const data = groupedData[month]
          if (data.count > 0) {
            chartData.push((data.energy / data.distance) * 100 || 0) // Verbrauch kWh/100km
          } else {
            chartData.push(0)
          }
        })
      } else if (this.selectedTimeRange === 'month') {
        // Gruppiere nach Tag (alle 3 Tage)
        const startDate = new Date()
        startDate.setDate(startDate.getDate() - 29)

        for (let i = 0; i <= 29; i += 3) {
          const currentDate = new Date(startDate)
          currentDate.setDate(startDate.getDate() + i)

          const label = currentDate.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' })
          groupedData[label] = { energy: 0, cost: 0, distance: 0, count: 0 }
        }

        filteredData.forEach((entry) => {
          const date = new Date(entry.date)
          const label = date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' })

          if (groupedData[label]) {
            groupedData[label].energy += parseFloat(entry.energy || 0)
            groupedData[label].cost += parseFloat(entry.cost || 0)
            groupedData[label].distance += parseFloat(entry.distance_driven || 0)
            groupedData[label].count += 1
          }
        })

        // Erstelle Labels und aggregierte Werte für das Diagramm
        Object.keys(groupedData).forEach((label) => {
          // console.log('Label TimeRange=Month:', label)
          labels.push(label)
          const data = groupedData[label]
          if (data.count > 0) {
            chartData.push((data.energy / data.distance) * 100 || 0) // Verbrauch kWh/100km
          } else {
            chartData.push(0)
          }
        })
      } else if (this.selectedTimeRange === 'week') {
        // Gruppiere nach Tag
        const weekdays = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So']
        weekdays.forEach((day) => {
          groupedData[day] = { energy: 0, cost: 0, distance: 0, count: 0 }
        })

        filteredData.forEach((entry) => {
          const date = new Date(entry.date)
          const label = date.toLocaleDateString('de-DE', { weekday: 'short' })

          if (groupedData[label]) {
            groupedData[label].energy += parseFloat(entry.energy || 0)
            groupedData[label].cost += parseFloat(entry.cost || 0)
            groupedData[label].distance += parseFloat(entry.distance_driven || 0)
            groupedData[label].count += 1
          }
        })

        // Erstelle Labels und aggregierte Werte für das Diagramm
        weekdays.forEach((day) => {
          labels.push(day)
          const data = groupedData[day]
          if (data.count > 0) {
            chartData.push((data.energy / data.distance) * 100 || 0) // Verbrauch kWh/100km
          } else {
            chartData.push(0)
          }
        })
      }
      console.log('data in generateConsumptionChartData:', chartData)
      return { labels, data: chartData }
    },
    renderConsumptionChart () {
      // console.log('renderConsumptionChart ()')
      // console.log('Daten im Rendering: ', this.consumptionData.chartData)
      console.log('Data in renderConsumptionChart:', this.consumptionData.chartData.data)
      if (!this.consumptionData.chartData || !this.consumptionData.chartData.labels || !this.consumptionData.chartData.data) {
        console.warn('Keine Daten für das Diagramm verfügbar.')
      }

      const ctx = document.getElementById('consumption-chart').getContext('2d')
      const labels = this.consumptionData.chartData.labels
      const data = this.consumptionData.chartData.data
      // console.log('renderConsumptionChart Labels:', labels)
      // console.log('renderConsumptionChart Daten:', data)
      // console.log('renderConsumptionChart CTX:', ctx)

      // Wenn die Instanz bereits existiert, aktualisiere nur die Daten
      if (this.consumptionChartInstance) {
        // console.log('aktualisiere Diagramm')
        this.consumptionChartInstance.data.labels = labels
        this.consumptionChartInstance.data.datasets[0].data = data
        this.consumptionChartInstance.update() // Aktualisiert das Diagramm
      } else {
        // Erstellt eine neue Instanz nur, wenn keine existiert
        // console.log('Erstelle neues Diagramm')
        this.consumptionChartInstance = new Chart(ctx, {
          type: 'line',
          data: {
            labels: labels,
            datasets: [
              {
                label: 'Energy Consumption',
                data: data,
                borderColor: '#007bff',
                backgroundColor: 'rgba(0, 123, 255, 0.2)',
                fill: true,
                tension: 0.4
              }
            ]
          },
          options: {
            responsive: true,
            plugins: {
              legend: {
                display: true,
                position: 'top'
              },
              tooltip: {
                callbacks: {
                  title: (tooltipItems) => tooltipItems[0].label,
                  label: (tooltipItem) => `${tooltipItem.raw} kWh`
                }
              }
            },
            scales: {
              x: {
                grid: {
                  display: false
                }
              },
              y: {
                ticks: {
                  callback: (value) => `${value} kWh`
                },
                grid: {
                  color: '#f0f3f5'
                }
              }
            }
          }
        })
      }
    },
    updateCurveData () {
      // console.log('updatCurveData ()')
      const socIntervals = Array.from({ length: 21 }, (_, i) => i * 5) // 0%, 5%, ..., 100%
      const temperatureCategories = ['<10°C', '10-20°C', '>20°C']

      const aggregatedData = socIntervals.map((interval) => {
        const aggregated = { SOC: interval, '<10°C': 0, '10-20°C': 0, '>20°C': 0, counts: { '<10°C': 0, '10-20°C': 0, '>20°C': 0 } }

        this.localData.forEach((entry) => {
          // console.log('lokale Daten für Ladekurve:', entry)
          const startSoc = parseFloat(entry.start_soc)
          const endSoc = parseFloat(entry.end_soc)
          const energy = parseFloat(entry.energy)
          const duration = parseFloat(entry.duration_minutes)
          const temperature = parseInt(entry.charge_temperature, 10)

          if (startSoc <= interval && endSoc > interval) {
            const power = energy / (duration / 60) // Ladeleistung in kW
            const socRange = (interval + 5 - interval) / (endSoc - startSoc)
            const intervalEnergy = power * (duration * socRange / 60) // Energie in kWh

            let tempCategory = '<10°C'
            if (temperature >= 10 && temperature <= 20) tempCategory = '10-20°C'
            else if (temperature > 20) tempCategory = '>20°C'

            aggregated[tempCategory] += intervalEnergy
            aggregated.counts[tempCategory] += 1
          }
        })

        temperatureCategories.forEach((cat) => {
          if (aggregated.counts[cat] > 0) {
            aggregated[cat] /= aggregated.counts[cat]
          }
        })

        return aggregated
      })

      this.curveData = { socIntervals, aggregatedData }
      // console.log('Aggregierte Daten für Ladekurven:', this.curveData)

      this.renderCurveChart()
    },
    renderCurveChart () {
      // console.log('renderCurceChart ()')
      const ctx = document.getElementById('curve-chart').getContext('2d')
      // console.log('Daten im Ladekurven-Rendering: ', this.curveData)
      if (this.curveChartInstance) {
        this.curveChartInstance.destroy()
      }

      const datasets = ['<10°C', '10-20°C', '>20°C'].map((category, index) => ({
        label: category,
        data: this.curveData.aggregatedData.map((d) => d[category]),
        borderColor: ['#FF6384', '#36A2EB', '#FFCE56'][index],
        backgroundColor: 'rgba(0,0,0,0)',
        tension: 0,
        pointRadius: 0,
        segment: {
          borderDash: (ctx) => (ctx.p0.skip || ctx.p1.skip ? [6, 6] : undefined) // Gehe zu gestrichelter Linie, wenn Punkt übersprungen wird
        },
        spanGaps: false // Lücken werden nicht übersprungen
      }))

      this.curveChartInstance = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.curveData.socIntervals.map((interval) => `${interval}-${interval + 5}%`),
          datasets
        },
        options: {
          responsive: true,
          plugins: {
            legend: { display: true, position: 'top' },
            tooltip: {
              callbacks: {
                title: (tooltipItems) => `SOC-Bereich: ${tooltipItems[0].label}`,
                label: (tooltipItem) => `${tooltipItem.raw.toFixed(2)} kW`
              }
            }
          },
          scales: {
            x: { title: { display: true, text: 'SOC-Bereich (%)' } },
            y: { title: { display: true, text: 'Ladeleistung (kW)' } }
          }
        }
      })
    }
  }
}
</script>
